module.exports = __webpack_public_path__ + "static/media/2022-11-14_Dr._Jill_Biden_on_stage_with_the_leaders.21cd45c8.png";